import * as React from "react";
import { ITriggerManualJob } from "../../../redux/types/ITriggerManualJob";
import { DRAFT_AGREEMENT_SUBMISSION_JOB_TYPE } from "../../Consts";
import { HIGH_WATER_MARK } from "../../../repertoire/Consts";
import ActionButton from "../../../repertoire/components/actionButton/ActionButton";
import {
    triggerManualJob,
} from "../../../redux/thunks/HomeThunks";
import DatePickerDataInput from "../../../repertoire/components/dateDataInput/DatePickerDataInput";

export interface IDraftAgreementSubmissionPostingJobParametersProps {
    createNewJob: () => any;
    getDaspHighWaterMark?: () => void;
    daspHighWaterMark?: any;
    setDaspHighWaterMark?: (hwm: string) => void;
    triggerManualJob: typeof triggerManualJob;
    updateManualJobParams?: (params: any) => void;
    scheduledJobSet?: (value: boolean) => void;
    onError?: (errorMessage: string) => void;
}


const DraftAgreementSubmissionPostingJobParameters = (props: IDraftAgreementSubmissionPostingJobParametersProps) => {

    React.useEffect(() => {
        const { getDaspHighWaterMark } = props;
        getDaspHighWaterMark();
    }, [])

    const handleHighWaterMarkChange = (value: string | boolean | Date, fieldname: string) => {
        const { setDaspHighWaterMark } = props;
        if (value) setDaspHighWaterMark(value.toString());
    }
    const [loading, setLoading] = React.useState(false);

    const onClickSave = () => {
        const { triggerManualJob, createNewJob, updateManualJobParams,scheduledJobSet, onError } = props;
        const { daspHighWaterMark } = props;

        const highWaterMark = daspHighWaterMark;
        setLoading(true);
        const manualJobParameters: ITriggerManualJob = {
            jobType: DRAFT_AGREEMENT_SUBMISSION_JOB_TYPE,
            jobParameters: JSON.stringify({
                highWaterMark,
            }),
        };

        try {
            scheduledJobSet(true);
            createNewJob();
            triggerManualJob(manualJobParameters);
            if (updateManualJobParams) {
                updateManualJobParams('');
            }
        } catch (err: any) {
            onError?.(err);
        } finally {
            setLoading(false);
        }

    };

    const { daspHighWaterMark } = props;

    return (
        <>
            <div className="row">
                <div className="form-group col-md-6 col-sm-6 col-xs-12">
                    <DatePickerDataInput
                        value={daspHighWaterMark}
                        fieldName={HIGH_WATER_MARK}
                        changeData={handleHighWaterMarkChange}
                        label={HIGH_WATER_MARK}
                        isHidden={false}
                        readOnly={false}
                    />
                </div>
            </div>

            <div className="row">
                <div
                    className="form-group col-lg-4 col-md-4 col-sm-6 col-xs-12">
                    <ActionButton buttonText={"Cancel"} buttonAction={props.createNewJob} className={"button btn-defaultSecondary"}/>
                </div>
                <div
                    className="form-group col-lg-4 col-lg-push-4 col-md-4 col-md-push-4 col-sm-6 col-sm-push-0 col-xs-12 col-xs-push-0">
                    <ActionButton
                        buttonText={"Start Job"}
                        buttonAction={() => onClickSave()}
                        disabled={loading}
                    />
                </div>
            </div>
        </>
    );
    
}

export default DraftAgreementSubmissionPostingJobParameters;

